<template>
    <div class="pt-2">
        <a
            class="inline-flex items-center justify-center font-semibold text-gray-700 hover:text-gray-500"
            :href="phoneLink"
        >
            <PhoneIcon class="h-5 w-5 mr-2" />
            {{ phone }}
        </a>
    </div>
</template>

<script setup lang="ts">
import { useGooglePhoneConversion } from "../../functions/useGooglePhoneConversion";
import { PhoneIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    headquarters?: any;
}>();

const { phone, phoneLink, swapWithForwardingNumber } =
    useGooglePhoneConversion();

phone.value = props.headquarters.phone;
phoneLink.value = props.headquarters.phoneLink;
swapWithForwardingNumber(props.headquarters.phone);
</script>
